export default {
  'workOrder.home.welcome': 'Welcome',
  'workOrder.common.create': 'Create Work Order',
  'workOrder.common.refresh': 'Refresh data',
  'workOrder.common.reload': 'Reload',
  'workOrder.common.view': 'View',
  'workOrder.common.all': 'All',
  'workOrder.common.none': 'No data',
  'workOrder.status.pending_accept': 'Pending Acceptance',
  'workOrder.status.processing': 'Processing',
  'workOrder.status.pending_confirm': 'Pending Confirmation',
  'workOrder.status.closed': 'Closed',
  'workOrder.status.cancelled': 'Cancelled',
  'workOrder.priority.low': 'Low',
  'workOrder.priority.normal': 'Normal',
  'workOrder.priority.high': 'High',
  'workOrder.priority.critical': 'Critical',
  'workOrder.list.title.all': 'All Work Orders',
  'workOrder.list.title.todo': 'My To-Do',
  'workOrder.list.title.mine': 'My Work Orders',
  'workOrder.list.ticketNo': 'Number',
  'workOrder.list.workOrderTitle': 'Title',
  'workOrder.list.priority': 'Priority',
  'workOrder.list.status': 'Status',
  'workOrder.list.createdAt': 'Created At',
  'workOrder.list.actions': 'Actions',
  'workOrder.create.title': 'Create Work Order',
  'workOrder.create.titleWithTemplate': 'Create {name}',
  'workOrder.create.submit': 'Submit Work Order',
  'workOrder.create.submitted': 'Work order submitted',
  'workOrder.create.basicInfo': 'Basic Information',
  'workOrder.create.extendedInfo': 'Additional Information',
  'workOrder.create.template': 'Work Order Template',
  'workOrder.create.templateRequired': 'Please select a work order template',
  'workOrder.create.workOrderTitle': 'Work Order Title',
  'workOrder.create.titleRequired': 'Please enter a work order title',
  'workOrder.template.title': 'Work Order Templates',
  'workOrder.template.create': 'Create Template',
  'workOrder.template.name': 'Template Name',
  'workOrder.template.code': 'Template Code',
  'workOrder.template.currentVersion': 'Current Version',
  'workOrder.template.unpublished': 'Unpublished',
  'workOrder.template.status': 'Status',
  'workOrder.template.draft': 'Draft',
  'workOrder.template.published': 'Published',
  'workOrder.template.enabled': 'Enabled',
  'workOrder.template.disabled': 'Disabled',
  'workOrder.template.lastPublishedAt': 'Last Published At',
  'workOrder.template.configure': 'Configure',
  'workOrder.template.copy': 'Copy',
  'workOrder.template.copied': 'Template copied',
  'workOrder.form.uploadAttachment': 'Upload attachment',
  'workOrder.puck.options': 'Options, one per line: label|code',
  'workOrder.puck.code': 'System code',
  'workOrder.puck.label': 'Display name',
  'workOrder.puck.helpText': 'Help text',
  'workOrder.puck.placeholder': 'Placeholder',
  'workOrder.puck.required': 'Required',
  'workOrder.puck.no': 'No',
  'workOrder.puck.yes': 'Yes',
  'workOrder.puck.initiatePermission': 'Initiation stage',
  'workOrder.puck.processPermission': 'Processing stage',
  'workOrder.puck.editable': 'Editable',
  'workOrder.puck.readonly': 'Read-only',
  'workOrder.puck.hidden': 'Hidden',
  'workOrder.puck.conditionFieldCode': 'Condition field code',
  'workOrder.puck.conditionOperator': 'Condition operator',
  'workOrder.puck.equals': 'Equals',
  'workOrder.puck.notEquals': 'Does not equal',
  'workOrder.puck.contains': 'Contains',
  'workOrder.puck.notEmpty': 'Is not empty',
  'workOrder.puck.conditionValue': 'Condition value',
  'workOrder.puck.attachmentAccept': 'Allowed file types',
  'workOrder.puck.attachmentSize': 'Maximum file size (MB)',
  'workOrder.puck.attachmentCount': 'Maximum file count',
  'workOrder.puck.selectFile': 'Select file',
  'workOrder.puck.fields': 'Work Order Fields',
  'workOrder.puck.layouts': 'Layout Components',
  'workOrder.puck.text': 'Single-line text',
  'workOrder.puck.textarea': 'Multi-line text',
  'workOrder.puck.number': 'Number',
  'workOrder.puck.select': 'Single select',
  'workOrder.puck.multiSelect': 'Multi-select',
  'workOrder.puck.date': 'Date',
  'workOrder.puck.dateRange': 'Date range',
  'workOrder.puck.member': 'Member picker',
  'workOrder.puck.attachment': 'Attachment',
  'workOrder.puck.switch': 'Switch',
  'workOrder.puck.oneColumn': 'One-column layout',
  'workOrder.puck.twoColumn': 'Two-column layout',
  'workOrder.puck.layoutName': 'Layout name',
  'workOrder.puck.group': 'Group',
  'workOrder.puck.groupName': 'Group name',
  'workOrder.puck.fieldGroup': 'Field group',
  'workOrder.editor.publishCheckFailed': 'Publication checks failed',
  'workOrder.editor.published': 'Template published',
  'workOrder.editor.draftSaved': 'Draft saved',
  'workOrder.editor.publishFailed':
    'Unable to publish the template. Try again later.',
  'workOrder.editor.draftSaveFailed':
    'Unable to save the draft. Try again later.',
  'workOrder.editor.editTitle': 'Edit Template',
  'workOrder.editor.saveDraft': 'Save Draft',
  'workOrder.editor.publish': 'Publish Template',
  'workOrder.editor.basicInfo': 'Basic Information',
  'workOrder.editor.formDesign': 'Form Design',
  'workOrder.editor.workflow': 'Workflow',
  'workOrder.editor.sla': 'SLA Settings',
  'workOrder.editor.publishCheck': 'Publication Checks',
  'workOrder.editor.nameRequired': 'Please enter a template name',
  'workOrder.editor.codeInvalid':
    'Use lowercase letters, numbers, and underscores only',
  'workOrder.editor.description': 'Description',
  'workOrder.editor.statCategory': 'Statistics Category',
  'workOrder.editor.enabled': 'Enabled',
  'workOrder.editor.preview': 'Live Preview',
  'workOrder.editor.deleteNode': 'Delete node',
  'workOrder.editor.nodeCode': 'Node code',
  'workOrder.editor.nodeName': 'Node name',
  'workOrder.editor.nodeType.accept': 'Accept',
  'workOrder.editor.nodeType.process': 'Process',
  'workOrder.editor.nodeType.ownerConfirm': 'Owner Confirmation',
  'workOrder.editor.nodeType.requesterConfirm': 'Requester Confirmation',
  'workOrder.editor.assignee.member': 'Specific Member',
  'workOrder.editor.assignee.role': 'Organization Role',
  'workOrder.editor.assignee.group': 'Candidate Group',
  'workOrder.editor.selectAssignee': 'Select assignee',
  'workOrder.editor.assigneeCode': 'Assignee code',
  'workOrder.editor.responseMinutes': 'Response minutes',
  'workOrder.editor.processMinutes': 'Processing minutes',
  'workOrder.editor.requiresResult': 'Require processing result',
  'workOrder.editor.addNode': 'Add Node',
  'workOrder.editor.warningLeadTime': 'Warning lead time',
  'workOrder.editor.minutes': '{value} min',
  'workOrder.editor.hour': '1 hour',
  'workOrder.editor.recheck': 'Check Again',
  'workOrder.editor.emptyChecks': 'Run checks to see results',
  'workOrder.editor.passed': 'Passed',
  'workOrder.editor.failed': 'Failed',
  'workOrder.editor.previous': 'Previous',
  'workOrder.editor.next': 'Next',
};
